import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#f39224',
    },
    error: {
      main: '#f44336',
    },
  },
});

export default theme;
